import './common/base';
import Vue from './vue/common/vue-common';
import CultureSection from './vue/components/work-here/CultureSection';

cr$.ready(function () {
    const el = cr$.byId('culture-vue').raw;
    if (el) {
        new Vue({
            el: el,
            template: `<CultureSection />`,
            components: { CultureSection },
        });
    }
});
